/* eslint-disable */

import { NavLink, useHistory, useLocation, useParams } from "react-router-dom";
// chakra imports
import {
  Box,
  Flex,
  HStack,
  Text,
  useColorModeValue,
  useMediaQuery,
} from "@chakra-ui/react";
import useGeneral from "hooks/use-general";
import { useEffect, useState } from "react";

export function SidebarLinks(props: { routes: RoutesType[] }) {
  const history = useHistory();
  //   Chakra color mode
  let location = useLocation();
  let activeColor = useColorModeValue("gray.700", "white");
  let inactiveColor = useColorModeValue(
    "secondaryGray.600",
    "secondaryGray.600"
  );
  let activeIcon = useColorModeValue("brand.500", "white");
  let textColor = useColorModeValue("secondaryGray.500", "white");
  let brandColor = useColorModeValue("brand.500", "brand.400");

  const { sideBarCollapse } = useGeneral();
  const [isSM] = useMediaQuery("(max-width: 640px)");
  const { routes } = props;

  // Extrai os parâmetros de consulta da URL
  const path = location.pathname;

  const partesDoCaminho = path.split("/");

  const textPathActive = partesDoCaminho[1];

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName: string) => {
    return location.pathname.includes(routeName);
  };

  const getRoute = (name: string) => {
    window.location.href = "#" + name;
    window.location.reload();
  };
  const [maxWidth, setMaxWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Função para atualizar o estado com o valor atual de max-width
    const updateMaxWidth = () => {
      setMaxWidth(window.innerWidth);
    };

    // Adicionar um ouvinte de evento de redimensionamento da janela
    window.addEventListener("resize", updateMaxWidth);

    // Remover o ouvinte de evento quando o componente é desmontado
    return () => {
      window.removeEventListener("resize", updateMaxWidth);
    };
  }, []);
  // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)
  const createLinks = (routes: RoutesType[]) => {
    return routes.map((route: RoutesType, index: number) => {
      if (route.layout === "/" + textPathActive) {
        return (
          <>
            {route.icon ? (
              <Box
                cursor="pointer"
                onClick={() => {
                  getRoute(route.layout + route.path);
                }}
              >
                <HStack
                  spacing={
                    activeRoute(route.path.toLowerCase()) ? "22px" : "26px"
                  }
                  py="5px"
                  bg={
                    activeRoute(route.path.toLowerCase())
                      ? brandColor
                      : "transparent"
                  }
                  borderRadius="8px"
                  ps="10px"
                  width={sideBarCollapse && !isSM ? "70px" : "none"}
                >
                  <Flex w="100%" alignItems="center" justifyContent="center">
                    <Box
                      color={
                        activeRoute(route.path.toLowerCase())
                          ? "white"
                          : textColor
                      }
                      me={sideBarCollapse && !isSM ? "1px" : "18px"}
                      ml={sideBarCollapse && !isSM ? "8px" : "none"}
                    >
                      {route.icon}
                    </Box>
                    {!sideBarCollapse && !isSM && (
                      <>
                        <Text
                          me="auto"
                          color={
                            activeRoute(route.path.toLowerCase())
                              ? "white"
                              : textColor
                          }
                          fontWeight={
                            activeRoute(route.path.toLowerCase())
                              ? "bold"
                              : "normal"
                          }
                        >
                          {route.name}
                        </Text>
                      </>
                    )}
                    {/*  */}
                  </Flex>
                  <Box
                    h="36px"
                    w="4px"
                    bg={
                      activeRoute(route.path.toLowerCase())
                        ? "yellow"
                        : "transparent"
                    }
                    borderRadius="5px"
                  />
                </HStack>
              </Box>
            ) : (
              <Box>
                <HStack
                  spacing={
                    activeRoute(route.path.toLowerCase()) ? "22px" : "26px"
                  }
                  py="5px"
                  ps="10px"
                >
                  <Text
                    me="auto"
                    color={
                      activeRoute(route.path.toLowerCase())
                        ? activeColor
                        : inactiveColor
                    }
                    fontWeight={
                      activeRoute(route.path.toLowerCase()) ? "bold" : "normal"
                    }
                  >
                    {route.name}
                  </Text>
                  <Box h="36px" w="4px" bg="brand.400" borderRadius="5px" />
                </HStack>
              </Box>
            )}
          </>
          // <NavLink key={index} to={route.layout + route.path}>

          // </NavLink>
        );
      }
    });
  };
  //  BRAND
  return <>{createLinks(routes)}</>;
}

export default SidebarLinks;
